import React, { createContext, useContext, useState, useEffect } from "react";
import i18n from "../i18n"; // adjust the path as necessary

interface LanguageContextValue {
  currentLanguage: string;
  setCurrentLanguage: (language: string) => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  currentLanguage: "English",
  setCurrentLanguage: () => {},
});

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error(
      "useLanguageContext must be used within a LanguageProvider"
    );
  }
  return context;
};

interface LanguageProviderProps {
  children: React.ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({
  children,
}) => {
  const [currentLanguage, setCurrentLanguage] = useState<string>("English");

  useEffect(() => {
    // This runs on mount. Check i18n's current language and set accordingly.
    const lang = i18n.language;
    if (lang === "en") {
      setCurrentLanguage("English");
    } else if (lang === "zh") {
      setCurrentLanguage("中文");
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ currentLanguage, setCurrentLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
